// extracted by mini-css-extract-plugin
export default {"header":"header--TKrQW","entityType":"entityType--UW9WB","displayName":"displayName--Qk1Mj"};